import NotebookSortOptions from "models/enumerations/sorting/notebooks/notebook-sort-options";
import NotebookService from "utilities/services/notebooks/notebook-service";

const useDashboardNotebooks = () => {
    const { list: listNotebookApi } = NotebookService.useListQuery();

    const { data: notebooksResult, isLoading } = listNotebookApi({
        skip: 0,
        take: 5,
        orderBy: NotebookSortOptions.CreatedOnDescending,
        findNewlyShared: true,
    });

    return {
        loading: isLoading,
        notebooks: notebooksResult?.resultObjects ?? [],
    };
};

export default useDashboardNotebooks;
